export enum RETURN_CODE {
    CENTRAL_RETURN = 'C',
    LOCAL_SCRAP = 'L',
    CENTRAL_SCRAP = 'S',
    BOOT_STOCK = 'G',
}

export enum CONSUME_CODE {
    CONSUMED = 'C',
    RETURN_WITHOUT_CONSUMPTION = 'D',
    LEFT_ON_NOTIFICATION = 'V',
    NOT_RECEIVED = 'X',
    CONSUMED_BILLABLE = 'CB',
}
// The name TUBE_INDICATOR refers to the Odata property received in NDP->PartSet,
// whereas the value indicates different types of Spare part

export enum TUBE_INDICATOR {
    DETECTOR_INDICATOR = 'D', // Detector
    HARDWARE_INDICATOR = 'H', // Computer (Hardware)
    IMAGE_INTENSIFIER_INDICATOR = 'I', // Image Intensifier (BV)
    TUBE_PART_INDICATOR = 'J', // Tube
    MEMORY_INDICATOR = 'M',
}

export enum SERIAL_P_INDICATOR {
    J_INDICATOR = 'J',
    D_INDICATOR = 'D',
}

export enum RETURN_REASON_CODE {
    DEAD_ON_ARRIVAL = '410',
    TRANSPORTATION_DAMAGE = '102',
    INCORRECT_DELIVERY = '380',
    ORIGINAL_PACKED = '370',
    DIAGNOSIS_SEALED = '361',
}

export enum CSE_STOCK {
    BOOT_STOCK = 'Boot Stock',
    OTHER_STOCK = 'Other Stock',
}

export enum AWB_RETURN_FIELD_NAME {
    CENTRAL_SCRAP = 'AWBReturnCS',
    CENTRAL_RETURN = 'AWBReturnCR',
    DANGEROUS_GOODS = 'AWBReturnDG',
    DEFAULT = 'AWBReturn',
}
